import { RecurrenceScheduleType } from 'modules/campaigns/lib/types';
import { Day } from 'modules/domains/campaign';
import { BaseOption } from 'ui/selects';

export const CAMPAIGN_RECURRENCE_OPTIONS: BaseOption<string | number>[] = [
  {
    id: RecurrenceScheduleType.DoNotRepeat,
    value: RecurrenceScheduleType.DoNotRepeat,
    label: "Don't repeat",
  },

  { id: RecurrenceScheduleType.Daily, value: RecurrenceScheduleType.Daily, label: 'Daily' },

  { id: RecurrenceScheduleType.Weekly, value: RecurrenceScheduleType.Weekly, label: 'Weekly' },

  {
    id: RecurrenceScheduleType.BiWeekly,
    value: RecurrenceScheduleType.BiWeekly,
    label: 'Every two weeks',
  },

  {
    id: RecurrenceScheduleType.ThirtyDays,
    value: RecurrenceScheduleType.ThirtyDays,
    label: 'Every 30 days',
  },

  {
    id: RecurrenceScheduleType.FirstOfTheMonth,
    value: RecurrenceScheduleType.FirstOfTheMonth,
    label: 'First of the month',
  },

  {
    id: RecurrenceScheduleType.FifteenTheOfTheMonth,
    value: RecurrenceScheduleType.FifteenTheOfTheMonth,
    label: '15th of the month',
  },

  {
    id: RecurrenceScheduleType.LastOfTheMonth,
    value: RecurrenceScheduleType.LastOfTheMonth,
    label: 'Last of the month',
  },

  {
    id: RecurrenceScheduleType.Custom,
    value: RecurrenceScheduleType.Custom,
    label: 'Custom',
  },
];

export const RECURRENCE_SCHEDULE_TYPES_WITH_SKIP_ON_DAYS = [
  RecurrenceScheduleType.Daily,
  RecurrenceScheduleType.Custom,
];

export const SEND_ON_DAYS_OPTIONS = [
  {
    id: Day.Monday,
    label: 'Mon',
  },
  {
    id: Day.Tuesday,
    label: 'Tue',
  },
  {
    id: Day.Wednesday,
    label: 'Wed',
  },
  {
    id: Day.Thursday,
    label: 'Thu',
  },
  {
    id: Day.Friday,
    label: 'Fri',
  },
  {
    id: Day.Saturday,
    label: 'Sat',
  },
  {
    id: Day.Sunday,
    label: 'Sun',
  },
];

export const SCHEDULE_CAMPAIGN_FORM_FIELDS = {
  END_TYPE: 'endType',
  PRE_CREATE_HOURS: 'precreateHours',
  RECURRENCE_FREQUENCY: 'recurrenceFrequency',
  SKIP_ON_DAYS: 'skipOnDays',
};
